import React, { useMemo, useState, useEffect } from 'react';
import { CpIcon, CpButton } from 'canopy-styleguide!sofe';
import CpClientAuth from 'cp-client-auth!sofe';

import { useNav } from '../../nav.context';
import { getGlobalPlusNavItems } from './global-plus-nav.helper';

import styles from './global-plus-nav.styles.css';

export const GlobalPlusNav = () => {
  const nav = useNav();
  const [betas, setBetas] = useState([]);

  useEffect(() => {
    const disposable = CpClientAuth.getLoggedInUserAsObservable().subscribe(loggedInUser => {
      setBetas(loggedInUser.betas);
    });
    return () => disposable.unsubscribe();
  }, []);

  const globalPlusNavItems = useMemo(() => getGlobalPlusNavItems(nav, betas), [nav.user, betas]);

  const enabledLinks = globalPlusNavItems.filter(link => link.enabled);

  const navButtons = enabledLinks.length > 3 ? enabledLinks.filter((link, index) => index < 3) : [];

  const navLinks = enabledLinks.length > 3 ? enabledLinks.filter((link, index) => index >= 3) : enabledLinks;

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <header className={styles.header}>
          <div className={`cps-wt-semibold ${styles.title}`}>Create</div>
          <CpButton
            icon="close-large"
            aria-label="Close"
            onClick={() => nav.setSecondaryOpen(null)}
          />
        </header>
        <section style={{ marginTop: '36px' }}>
          <div className={styles.flexSpread}>
            {navButtons.map(navButton => {
              return (
                navButton.enabled && (
                  <div className={styles.navButtonWrapper} key={navButton.id}>
                    <div
                      className={styles.navButton}
                      onClick={() => {
                        nav.setSecondaryOpen(null);
                        navButton.action();
                      }}>
                      <CpIcon name={navButton.icon} size="28" />
                    </div>
                    <div className={`${styles.nabButtonLabel} cps-caption cps-wt-semibold`}>{navButton.label}</div>
                  </div>
                )
              );
            })}
          </div>
        </section>
      </div>
      <section className={styles.navBottomSection}>
        <ul className={styles.navLinks}>
          {navLinks.map(navLink => {
            return (
              navLink.enabled && (
                <li
                  key={navLink.label}
                  className={styles.navLink}
                  onClick={() => {
                    nav.setSecondaryOpen(null);
                    navLink.action();
                  }}>
                  <div className={`cps-wt-semibold cps-color-primary cps-body ${styles.navLinkTitle}`}>
                    <div>{navLink.label}</div>
                    <CpIcon name="caret-large-right" />
                  </div>
                  <div className={styles.navLinkDesc}>{navLink.desc}</div>
                </li>
              )
            );
          })}
        </ul>
      </section>
    </div>
  );
};
